import React, { createContext, useContext, ReactNode } from 'react';
import { useThemeColors } from '../hooks/useQueryPerams';

interface ThemeContextType {
  themeColors: Record<string, string>;
  getThemeColor: (colorKey: string, fallback?: string) => string;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface ThemeProviderProps {
  children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const themeColors = useThemeColors();
  const getThemeColor = (colorKey: string, fallback: string = '#7c3aed'): string => {
    return themeColors[colorKey] || fallback;
  };

  return (
    <ThemeContext.Provider value={{ themeColors, getThemeColor }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
} 